import React from 'react';

export default function Imports() {
  const imports = [
    { name: 'Honda Type R', years: '2022–2026' },
    { name: 'Lexus IS', years: '2020–2022' },
    { name: 'Honda Grace', years: '2020' },
    { name: 'Toyota Hiace (14-seater)', years: '2019–2025' },
    { name: 'BMW M Sport', years: 'Various' },
    { name: 'Mercedes-Benz AMG 63', years: 'Various' },
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl sm:text-5xl font-bold">Imports</h1>
        <p className="mt-4 text-gray-200 max-w-3xl">
          We can source and import vehicles to match your preferences. Tell us the make/model/year range you want and we’ll handle the process.
        </p>

        <div className="mt-8 grid md:grid-cols-2 gap-6">
          {imports.map((item) => (
            <div key={item.name} className="bg-gray-900/60 border border-red-700/40 rounded-2xl p-6">
              <div className="text-xl font-bold text-white">{item.name}</div>
              <div className="text-red-300 font-semibold mt-1">{item.years}</div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-gray-900/40 border border-red-700/30 rounded-2xl p-6">
          <h2 className="text-2xl font-bold text-red-300">International Sales</h2>
          <p className="mt-2 text-gray-200">
            We sell vehicles locally and internationally, including Jamaica, Grand Cayman Islands, Dominican Republic, and Trinidad.
          </p>
        </div>
      </div>
    </div>
  );
}
